import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppRoutingRoutingModule } from './app-routing-routing.module';
import { RouterModule, Routes } from '@angular/router';
import { RoutesEnum } from './enums/routes-enum';
import { SigninComponent } from './login/signin/signin.component';
import { DashbordComponent } from './components/employe/dashbord/dashbord.component';
import { SignupComponent } from './login/signup/signup.component';
import { FourOhFourComponentComponent } from './four-oh-four-component/four-oh-four-component.component';
import { AuthGuard } from './auth.guard';
import { KidsComponent } from './components/marchand/kids/kids.component';
import { DashboardMarchandComponent } from './components/marchand/dashboard-marchand/dashboard-marchand.component';
import { ProfilComponent } from './components/employe/profil/profil.component';
import { SoldeComponent } from './components/employe/solde/solde.component';
import { AccountActivationComponent } from './account-activation/account-activation.component';
import { FirstLoginChangePasswordComponent } from './features/auth/first-login-change-password/first-login-change-password.component';

const routes: Routes = [
  { path: RoutesEnum.signinRoute, component: SigninComponent },
  { path: RoutesEnum.signinupRoute, redirectTo: RoutesEnum.signinRoute, pathMatch: 'full' },
  { path: RoutesEnum.signinRouteM, component: SigninComponent },
  { path: RoutesEnum.signinupRouteM, redirectTo: RoutesEnum.signinRouteM, pathMatch: 'full' },
  {
    path: RoutesEnum.activateRouteCompany,
    component: AccountActivationComponent,
  },
  {
    path: RoutesEnum.activateRouteMerchant,
    component: AccountActivationComponent,
  },
  
  {
    path: RoutesEnum.TitreRestoRoute,
    component: DashbordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RoutesEnum.ChequeVacanceRoute,
    component: DashbordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RoutesEnum.ChequeCadeauRoute,
    component: DashbordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RoutesEnum.BonsEssenceRoute,
    component: DashbordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RoutesEnum.ProfilRoute,
    component: DashbordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RoutesEnum.AideRoute,
    component: DashbordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RoutesEnum.ProfilRouteMerchant,
    component: DashboardMarchandComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RoutesEnum.SoldeRoute,
    component: DashbordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RoutesEnum.SoldeRouteM,
    component: DashboardMarchandComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RoutesEnum.QrCodeRouteM,
    component: DashboardMarchandComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RoutesEnum.kidsRouteM,
    component: DashboardMarchandComponent,
    canActivate: [AuthGuard],
  },

  {
    path: RoutesEnum.BonsRouteM,
    component: DashboardMarchandComponent,
    canActivate: [AuthGuard],
  },

  {
    path: RoutesEnum.TransactionRouteM,
    component: DashboardMarchandComponent,
    canActivate: [AuthGuard],
  },
  {
    path: RoutesEnum.AideRouteM,
    component: DashboardMarchandComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'company/change-password',
    component: FirstLoginChangePasswordComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'merchant/change-password',
    component: FirstLoginChangePasswordComponent,
    canActivate: [AuthGuard],
  },

  {
    path: '',
    pathMatch: 'full',
    redirectTo: true ? 'company/signin' : `${'/' + RoutesEnum.TitreRestoRoute}`,
  },
  { path: RoutesEnum.notFoundRoute, component: FourOhFourComponentComponent },
  { path: '**', redirectTo: `${'/' + RoutesEnum.notFoundRoute}` },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes),
    CommonModule,
    AppRoutingRoutingModule,
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
